// 平台应用的一些配置
import { COU_regOneStr } from "@/utils/co_util"

// PDD上货应用的appKey 
export const Service_AppKey = `2021004123671377`

// 获取授权成功后的参数 loginCode
export function Service_GetLoginCode(){
  return COU_regOneStr(location.search, /loginCode=(\w+)/)
}

//获取本地选择店铺的key(下单获取多店铺的relId)
export function Service_GetCheckedReIdListLocalKey() {
  // 因为有店群的存在, 用户可能会切换店群,所以带上GroupId
  return `xf_checkedRelationList_${Service_GetGroupIdByLocal() || ''}`
}



//(店群中的店铺相关操作) ----------------------------------------------------------------------
// 本地存储的支付宝店铺授权的key
export const Service_zfb_xf_move_member_key = `zfb_xf_order_member_key`

// 从本地获取支付宝店铺信息
export function Service_GetZfbMemberInfo() {
  if (localStorage.getItem(Service_zfb_xf_move_member_key)) return JSON.parse(localStorage.getItem(Service_zfb_xf_move_member_key))
  return {}
}

// 获取支付宝授权账号的token
export function Service_GetZfbMemberToken() {
  const memberInfo = localStorage.getItem(Service_zfb_xf_move_member_key)
  return memberInfo ? JSON.parse(memberInfo)?.token : ''
}

// 获取支付宝授权账号的Info
export function Service_SetZfbMemberInfo(data) {
  localStorage.setItem(Service_zfb_xf_move_member_key, JSON.stringify(data))
}


//(店群相关操作) ---------------------------------------------------------------------------------
// groupId 的相关本地操作
export const Service_LocalGroupIdKey = `zfb_xf_shanghuo_currentGroupId`

export function Service_SetGroupIdToLocal(GroupId) {
  localStorage.setItem(Service_LocalGroupIdKey,GroupId)
}

export function Service_GetGroupIdByLocal() {
  return localStorage.getItem(Service_LocalGroupIdKey) || ''
}

export const move_success_key = `zfb_xiaofeng_shanghuo_is_moved_success_ids`